import React, { type FC, type PropsWithChildren } from 'react';

import { isDefined } from '@lucid/utils';
import { withImage } from '@lucid/hooks';
import { Box, Link, Container, Image } from '@lucid/components';

import type { Lucid } from 'types/types';

const FlexiCertSection: FC<PropsWithChildren<Lucid.Directus.Generated.Flexi_Cert_Section>> = ({ items }) => (
  <Box
    as="section"
    css={theme => ({
      backgroundColor: theme.colors.coolGrey[10],
      flex: '0 1 100%',
      maxWidth: '100%',
      paddingTop: theme.space.s32,
      paddingBottom: theme.space.s32,
    })}
  >
    <Container css={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box css={{ margin: '0 auto' }}>
        {items &&
          items.filter(isDefined).map(({ image, link }, i) => (
            <Box key={`certification-item_${i}`}>
              {image?.filename_disk && (
                <Image
                  css={{
                    maxHeight: '200px',
                  }}
                  imageAlt={image.title || ''}
                  imageSrc={withImage(image)}
                />
              )}
              {link && (
                <Link
                  data-ga-description={`nineteen-certification-item-${i}`}
                  href={link.final_url}
                  iconAnimation="navigational"
                >
                  {link.default_link_text}
                </Link>
              )}
            </Box>
          ))}
      </Box>
    </Container>
  </Box>
);

export default FlexiCertSection;
